import { Badge, Breadcrumb, Button, Card, Col, Dropdown, Flex, Row, Space } from "antd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import TableAntd from "components/elements/Table";
import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useState } from "react";
import dayjs from "dayjs";
import ExpenseCreateModal from "./ExpenseCreateModal";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import ExpenseRequestFilter from "./ExpenseRequestFilter";
import { useSelector } from "react-redux";
import ExpenseTableList from "./ExpenseTableList";

const ExpenseMainComponent = ({
    expenseRequestPagination = [],
    expenseYearSummaryChart = [],
    MonthlyExpenseChart = () => { },
    onEdit = () => { },
    onView = () => { },
    ExpenseDonutChart = () => { },
    initialValues = {},
    updateMyTxnExpense = () => { },
    updateMyTxnExpenseDraft = () => { },
    createTxnExpense = () => { },
    createTxnExpenseDraft = () => { },
    txnExpenseById = {},
    dropdownProjectByEmployeeId = [],
    dropdownWelfareSubTypeByCode = [],
    getDropdownWelfareSubTypeByCode = [],
    EmployeeWelfareDropdown = [],
    CommonTypeByCode = [],
    onSubmit = () => { },
    setEditExpenseForm = () => { },
    isEditExpenseForm = false,
    pagination = {},
    onPageChange = () => { },
    onCreate = () => { },
    isExpenseModalOpen = false,
    setIsExpenseModalOpen = () => { },
    handleSearchFilter = () => { },
    form,
    currentExpenseWorkflow = [],
    onSubmitCreate = () => { },
    onSubmitCreateDraft = () => { },
    onAttachFileChange = () => { },
    onDeleteFile = () => { },
    onRejectExpense=()=>{}
}) => {
    const { t, i18n } = useTranslation();
    const [isCreateExpenseForm, setCreateExpenseForm] = useState(false);
    const [isViewExpenseForm, setViewExpenseForm] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [useFilter, setUseFilter] = useState(false);
    const { roles } = useSelector((state) => state.company);

    const handleEdit = (record) => {
        setSelectedRecord(record);
        setCreateExpenseForm(false);
        setViewExpenseForm(false);
        setIsExpenseModalOpen(true);
        onEdit(record);
    };

    const handleCreate = () => {
        form.resetFields();
        setCreateExpenseForm(true);
        setEditExpenseForm(false);
        setViewExpenseForm(false);
        setIsExpenseModalOpen(true);
    };
    const handleView = (record) => {
        setViewExpenseForm(true);
        setEditExpenseForm(false);
        setCreateExpenseForm(false);
        setIsExpenseModalOpen(true);
        onView(record);
    };

    return (
        <MainLayout>
            <ExpenseCreateModal
                isExpenseModalOpen={isExpenseModalOpen}
                setIsExpenseModalOpen={setIsExpenseModalOpen}
                isCreateExpenseForm={isCreateExpenseForm}
                isEditExpenseForm={isEditExpenseForm}
                isViewExpenseForm={isViewExpenseForm}
                txnExpenseById={txnExpenseById}
                initialValues={initialValues}
                updateMyTxnExpense={updateMyTxnExpense}
                updateMyTxnExpenseDraft={updateMyTxnExpenseDraft}
                getDropdownWelfareSubTypeByCode={getDropdownWelfareSubTypeByCode}
                dropdownWelfareSubTypeByCode={dropdownWelfareSubTypeByCode}
                dropdownProjectByEmployeeId={dropdownProjectByEmployeeId}
                onSubmit={onSubmit}
                selectedRecord={selectedRecord}
                createTxnExpense={createTxnExpense}
                createTxnExpenseDraft={createTxnExpenseDraft}
                EmployeeWelfareDropdown={EmployeeWelfareDropdown}
                CommonTypeByCode={CommonTypeByCode}
                onCreate={onCreate}
                form={form}
                currentExpenseWorkflow={currentExpenseWorkflow}
                onSubmitCreate={onSubmitCreate}
                onSubmitCreateDraft={onSubmitCreateDraft}
                onAttachFileChange={onAttachFileChange}
                onDeleteFile={onDeleteFile}
                onReject={onRejectExpense}
            />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb
                        items={[
                            { title: t("home.header"), href: "/" },
                            { title: t("expense.header") },
                        ]}
                    />
                    <h2>{t('expense.header')}</h2>
                </Flex>

                <Row style={{ width: "100%", display: "flex", alignItems: "stretch" }}>
                    <Col span={16} style={{ paddingRight: "8px", display: "flex" }}>
                        <Card
                            style={{
                                flex: 1,
                                backgroundColor: "white",
                                width: "100%",
                                height: "100%",
                                boxShadow: "0px 4px 2px 0px rgba(0, 0, 0, 0.15)",
                                borderRadius: "16px",
                                border: "solid 1px #EAECF0",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <MonthlyExpenseChart />
                        </Card>
                    </Col>

                    <Col span={8} style={{ paddingLeft: "8px", display: "flex" }}>
                        <Card
                            style={{
                                flex: 1,
                                backgroundColor: "white",
                                width: "100%",
                                height: "100%",
                                boxShadow: "0px 4px 2px 0px rgba(0, 0, 0, 0.15)",
                                borderRadius: "16px",
                                border: "solid 1px #EAECF0",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <ExpenseDonutChart />
                        </Card>
                    </Col>
                </Row>
                <Row justify={"end"} style={{ gap: "8px" }}>
                    <Button
                        type="default"
                        style={{ display: "flex", alignItems: "center", color: "#667085" }}
                        icon={<FilterIcon style={{ fontSize: 16 }} />}
                        size="large"
                        onClick={() => setUseFilter(!useFilter)}
                    >
                        {t("common.filter")}
                    </Button>

                    {roles.includes("CREATE_EXPENSE|HOME") && (
                        <Button
                            type="primary"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "var(--button-color)"
                            }}
                            icon={<CreateIcon style={{ fontSize: 16 }} />}
                            size="large"
                            onClick={handleCreate}
                        >
                            {t("my_document.create")}
                        </Button>
                    )}
                </Row>

                {useFilter &&
                    <Card width="100%" style={{ border: "1px solid #EAECF0", borderRadius: "8px" }} >
                        <ExpenseRequestFilter
                            handleSearchFilter={handleSearchFilter}
                            dropdownWelfareSubTypeByCode={dropdownWelfareSubTypeByCode}
                        />
                    </Card>
                }

                {/* <TableAntd
                    columns={columns}
                    dataSource={expenseRequestPagination}
                    onChange={onPageChange}
                    pagination={{
                        ...pagination
                    }}
                /> */}

                <ExpenseTableList
                    dataSource={expenseRequestPagination}
                    handleView={handleView}
                    onPageChange={onPageChange}
                    pagination={pagination}
                    handleEdit={handleEdit}
                />
            </Space>
        </MainLayout>
    );
};

export default ExpenseMainComponent;
